// extracted by mini-css-extract-plugin
var _1 = "AccordionStepper-module__stepContainer--XA62G";
export { _1 as "stepContainer" }
